import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';


interface LogoProps {
  variant?: 'header' | 'footer';
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const Logo: React.FC<LogoProps> = ({

  showText = true,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  const iconSizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <Link to="/" className="group inline-flex items-center gap-3">
      <img src='/logo.png' alt="amasQIS Logo" className={`${sizeClasses[size]} ${iconSizeClasses[size]}`} />

      {showText && (
        <motion.div
          whileHover={{
            textShadow: "0 0 20px rgba(0, 207, 255, 0.8)"
          }}
          className={`${textSizeClasses[size]} font-bold transition-all duration-500`}
          style={{
            fontFamily: "'Comfortaa', sans-serif",
            background: 'linear-gradient(135deg, #00CFFF 0%, #0FFFA0 50%, #8A3FFC 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'white',
            backgroundClip: 'text'
          }}
        >
          amasQIS.ai
        </motion.div>
      )}
    </Link>
  );
};